<template>
  <div class="blog-banner">
    <div class="grid grid--container blog-banner__content">
      <div class="row row--lg-h-center">
        <div :class="`col ${columns}`">
          <VText variant="h1" itemprop="headline">{{ title }}</VText>
          <VText itemprop="description">{{ description }}</VText>
          <slot />
        </div>
      </div>
    </div>
    <div class="grid grid--container grid--no-gutters">
      <RatioBox :ratio="+imageWidth / +imageHeight">
        <nuxt-img
          class="blog-banner__img"
          :src="image"
          :alt="imageAlt"
          :height="imageHeight"
          :width="imageWidth"
          loading="lazy"
          :sizes="`xs:100vw md:100vw lg:${imageWidth}px`"
        />
      </RatioBox>
    </div>
  </div>
</template>

<script>
import { VText, RatioBox } from '@campsite-bio/component-lib';

export default {
  components: {
    VText,
    RatioBox,
  },

  props: {
    columns: {
      type: String,
      default: 'col--lg-8 col--md-10',
    },
    image: String,
    imageAlt: String,
    imageHeight: String,
    imageWidth: String,
    title: String,
    description: String,
  },
};
</script>

<style lang="scss" scoped>
.blog-banner {
  &__content {
    padding-bottom: 2.34375rem;
    padding-top: 2.34375rem;

    h1 {
      margin: 0 0 0.625rem;
    }

    p {
      margin: 0;
    }
  }

  &__img {
    border: 1px solid var(--g-color-gray-200);
    width: 100%;
    object-fit: cover;
    max-width: 100%;
  }
}
</style>
